import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./AboutUs.css";
import img1 from "../../../../assets/images/story1.jpg"; // Top
import img2 from "../../../../assets/images/story2.jpg"; // Middle
import img3 from "../../../../assets/images/story3.jpg"; // Bottom
import { Images } from '../../../../assets/assets';
import { Link } from 'react-router-dom';
import { useAboutUsStore } from "../../../../store/useAboutUsStore";
import { useState } from "react";
import Loader from "../../../Loader";
const WhoWeAre = () => {

  let { story, getAbout } = useAboutUsStore();
  const [loading, setLoading] = useState(false)

  const fetchAboutUs = async () => {
    if (story) return
    setLoading(true)
    await getAbout();
    setLoading(false)
  }

  useEffect(() => {
    fetchAboutUs();
  }, [])
  return (
    <section className="our-story-section">
      <Loader loading={loading}>
        <Container className="theme-container">
          <Row className="align-items-center">
            <Col lg={6}>
              <div className="our-story-left-col-content">
                <p className="section-subtitle mb-2">
                  {story?.subTitle}
                </p>
                <h3 className="mb-4">{story?.title}</h3>
                <p className="text-light-gray mb-lg-3 mb-2">
                  {story?.description?.split("\n").map((line, idx) => (
                    <span key={idx}>
                      {line} <br />
                    </span>
                  ))}
                </p>

                <div className='btn-holder mt-xl-5 mt-lg-4 mt-md-3 mt-2'>
                  <Link to="/contact-us" className="btn btn-solid-black">
                    <span className="fw-bold me-3 ">{story?.buttonText}</span>
                    <img className="img-fluid" src={Images.FancyWhiteCornerIcon} alt="Phone icon" />
                  </Link>
                </div>
              </div>
            </Col>

            <Col lg={6}>
              <div className="image-cluster-grid">
                {story?.images?.[0] && (
                  <div className="story-img img-1">
                    <img src={story.images[0]} alt="Top Construction" className="img-fluid" />
                  </div>
                )}
                {story?.images?.[1] && (
                  <div className="story-img img-2">
                    <img src={story.images[1]} alt="Middle Construction" className="img-fluid" />
                  </div>
                )}
                {story?.images?.[2] && (
                  <div className="story-img img-3">
                    <img src={story.images[2]} alt="Bottom Construction" className="img-fluid" />
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </Loader>
    </section>
  );
};

export default WhoWeAre;
